<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 20 20"
        :fill="color"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ color }"
    >
        <path d="M0 8.5H9.02437V11.5H0V8.5ZM10.9756 8.5H20V11.5H10.9756V8.5Z"></path>
    </svg>
</template>

<script>
export default {
    name: 'DashesSVG',
    props: {
        size: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
};
</script>

<style></style>
